export type IssueTypeAvailability = {
  hasEpic: boolean;
  hasStory: boolean;
  hasTask: boolean;
  missingTypes: string[];
};

export const DEFAULT_ISSUE_TYPE_AVAILABILITY: IssueTypeAvailability = {
  hasEpic: true,
  hasStory: true,
  hasTask: true,
  missingTypes: []
};
